/**
 * The wizard step order. Row n - 1 is step n: `state` is the `touched` and
 * `errors` key, `api` the /v1/account parameter, `ga` the GA4 step name.
 * Step 0, `oauth_complete`, is flashed by Auth::continueSignupInWizard().
 */
export const STEPS = [
    { state: 'email', api: 'email', ga: 'email' },
    { state: 'name', api: 'name', ga: 'name' },
    { state: 'birthday', api: 'birthday', ga: 'birthday' },
    { state: 'sex', api: 'sex', ga: 'sex' },
    { state: 'currentCity', api: 'city_id', ga: 'current_city' },
    { state: 'homeCity', api: 'home_city_id', ga: 'home_city' },
    { state: 'password', api: 'password', ga: 'password' },
    { state: 'username', api: 'username', ga: 'username' }
];

export function getFieldForStep(step) {
    return STEPS[step - 1]?.state;
}

export function getStepForField(field) {
    return STEPS.findIndex((row) => row.state === field) + 1;
}

export function getApiFieldForStep(step) {
    return STEPS[step - 1]?.api || '';
}

export function getStepForApiField(field) {
    return STEPS.findIndex((row) => row.api === field) + 1;
}

export function getStepName(step) {
    return STEPS[step - 1]?.ga || '';
}
